import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  border-radius: 20px;
  border: 1px solid var(--alias-color-line-normal);
  overflow: visible;
`;

export const HeaderContainer = styled.div`
  display: flex;
  padding: 20px 28px;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  border-radius: 20px 20px 0px 0px;

  background: var(--alias-color-background-normal-alternative);
`;

export const LeftSideContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
`;
